import rateioInput from './rateioInput';
const template = require('lodash/template')
const templateValidationPolicyErrorsCreateExpense = template(require('../templates/erros-validacao-politica-criacao-despesa.html'));
const templateErrorsCreateExpense = template(require('../templates/erros-criacao-despesa.html'));
const GlobalAlerts = require('./GlobalAlerts');
const Lang = require('lang');
const ValidarReciboPercurso = require('./ValidarReciboPercurso')
const ga4 = require('../ga4/ga4');

const nameInputValidado = 'validado';

function GeneralFormsExpense() {
  const modals = document.querySelectorAll('[data-general-forms-expenses]');
  if (!modals.length) {
    return;
  }

  settings(modals);
}

function settings(modals) {
  modals.forEach(modal => {
    const form = modal.querySelector('form');
    const buttonSubmit = form.querySelector('[data-form-submit]');
    const inputObs = form.querySelector('[name="obs"]');

    // Definindo no formulário o valor default do required do campo observação
    // esta definição acontece porque este valor pode ser modificado durante o
    // envio da política
    form.setAttribute('data-form-submit-obs-required', inputObs.dataset.ruleRequired);

    // Inicializando as inputs de rateio
    rateioInput.init(modal);

    // Listener do butão de submit do formulário
    buttonSubmit.addEventListener('click', (event) => {
      handlerClickButtonSubmit(form);
    });
  });
}

/**
 * Evento padrão de click Submit
 *
 * Evento padrão de submit do formulário de despesa, apenas aplica a
 * validação do fomulário antes de chamar o método de envio da request
 *
 * @param {Element} form
 */
function handlerClickButtonSubmit(form) {
  const rateioIsValid = rateioInput.validate(form);
  const formIsValid = $(form).valid();
  const receiptIsValid = ValidarReciboPercurso(form);

  if (!rateioIsValid || !formIsValid || !receiptIsValid) {
    return;
  }

  sendRequestSubmit(form);
}

/**
 * Exibir erros de Política
 *
 * Exibir o dialog contendo os erros de validação da política
 * durante o pedido de criação da despesa
 *
 * @param {Object} error
 * @param {Element} form
 */
function showLimitPolicyValidationErrors(error, form) {
  const data = error.data;
  const buttons = {};

  buttons.cancel = {
    label: Lang.get('js/common/form/button.cancel'),
    className: 'btn-danger'
  };

  if (data.allowExceedLimit === true) {
    buttons.confirm = {
      label: Lang.get('js/common/form/button.confirm'),
      className: 'btn-info btn-click-delay',
      callback: function () {
        // Bloqueando botao para nao duplicar despesas
        $('.btn-click-delay').prop('disabled', true);
        setTimeout(() => $('.btn-click-delay').prop('disabled', false), 500);
        // Alterando a input obs para required caso essa seja
        // uma exigência da política
        if (data.requireNotes && form.querySelector('[name="obs"]').value === '') {
          bootbox.alert({
            title: Lang.get('js/src/functions/ExpenseLimit.no_observation'),
            message: Lang.get(
              'js/src/functions/ExpenseLimit.show_needs_observation_message',
              { description: $(form).find('#idDespesaTipo').text() }
            ),
            closeButton: false,
          });
          toggleRequiredObsAttribute(form, data.requireNotes);
        }
        // Adicionando a input de confirmação para ultrapasasr a política
        appendInputConfirmationToExceedLimit(form);

        handlerClickButtonSubmit(form);
      }
    }
  }

  bootbox.dialog({
    title: error.message,
    message: templateValidationPolicyErrorsCreateExpense({
      errors: data.failures
    }),
    buttons: buttons
  });
}

/**
 * Erro genérico para a falhas na criação de despesas
 *
 * @param {Object} error
 * @param {Element} form
 */
function showGenericErrorsCreateExpense(error, form) {
  const fails = [];

  if (Object.keys(error.data).length) {
    Object.keys(error.data).forEach((key) => {
      const element = form.querySelector(`#${key}`);
      const validErrorKeys = ['recibo', 'fileSize'];
      if (document.body.contains(element) || validErrorKeys.includes(key)) {
        fails.push(error.data[key]);
      }
    });
  }

  bootbox.dialog({
    title: Lang.get('js/src/functions/GeneralFormExpense.ops'),
    message: templateErrorsCreateExpense({
      errors: fails,
      message: error.message
    }),
    buttons: {
      cancel: {
        label: Lang.get('js/common/form/button.cancel'),
        className: 'btn-danger'
      }
    }
  });
}

/**
 * Adicionar input Exceder limit política
 *
 * Adiciona input que confirma a criação da despesa mesmo
 * excedendo o limite da política
 *
 * @param {Element} form
 */
function appendInputConfirmationToExceedLimit(form) {
  const input = document.createElement('input');
  input.name = nameInputValidado;
  input.id = input.name;
  input.className = 'hidden';
  input.value = 'N';

  form.appendChild(input);
}

/**
 * Remover input de Exceder Limite Política
 *
 * Remove a input de confirmação para exceder o limite
 * da política do formulário
 *
 * @param {Element} form
 */
function removeInputConfirmationToExceedLimite(form) {
  const inputConfirmationToExceedLimit = document.querySelector(`#${nameInputValidado}`);
  if (document.body.contains(inputConfirmationToExceedLimit)) {
    form.removeChild(inputConfirmationToExceedLimit);
  }
}

/**
 * Remover input de apagar recibo
 *
 * Remove a input que solicita exclusão do recibo da despesa
 *
 * @param {Element} form
 */
function removeInputRemoverRecibo(form) {
  const inputRemoveRecibo = document.querySelector('#removerRecibo');
  if (document.body.contains(inputRemoveRecibo)) {
    inputRemoveRecibo.remove();
  }
}

/**
 * Gerenciar obrigatoriedade de Observação
 *
 * Ativar/desativar a required do campo de observação da
 * do formulário de criação de despesa
 *
 * @param {Element} form
 * @param {bool} value
 */
function toggleRequiredObsAttribute(form, value) {
  const inputExbigeObs = form.querySelector('[name="obs"]');
  if (!value || value) {
    inputExbigeObs.setAttribute('data-rule-required', value);
    return;
  }
  inputExbigeObs.removeAttibute('data-rule-required');
}

/**
 * Realiza o reload da página retirando as ancoras
 * da url
 */
function reloadPage() {
  const currentUrl = window.location.href;
  return window.location = currentUrl.split('#')[0];
}

/*******************************************************************************
 *
 * REQUEST E DADOS PARA SEREM ENVIADOS
 *
********************************************************************************/

/**
 * Enviar a request
 *
 * Este método utiliza os atributos do próprio formulário para determinar
 * os valores que devem ser eviados, a url que deve ser eviada e o tipo
 * de método que também deve ser utilizado
 *
 * @param {Element} form
 * @param {boolean} refreshOnSuccess
 * @param {boolean} closeModalOnSuccess
 */
function sendRequestSubmit(form, refreshOnSuccess = true, closeModalOnSuccess = true) {
  $(form).overlay({ fixed: true });
  $(form).overlay('show');

  const modal = form.closest('[data-general-forms-expenses]');
  const inputsDisabled = form.querySelectorAll('[disabled]');
  const buttonSubmit = form.querySelectorAll('[data-form-submit]');
  const modalsID = ['expense', 'percurso', 'percurso-mapa'];
  const modalGA4 = ['expensesModal_save', 'expensesModalRoute_save', 'expensesModalMap_save'];
  const index = modalsID.indexOf($(modal).data('general-forms-expenses'));

  // Reabilitando as inputs para envio da request
  toggleDisabledInputs(inputsDisabled);
  // Desabilitando o botão de submit para não permitir clicar duas vezes
  toggleDisabledInputs(buttonSubmit);

  let formData = new FormData(form);
  formData = setRateioInFormData(form, formData, formData.get('valor'));
  formData = setReceiptInFormData(form, formData);
  formData = setMileageInFormData(form, formData);

  const ajax = $.ajax({
    url: form.action,
    method: 'POST',
    data: formData,
    contentType: false,
    processData: false
  });

  Promise.resolve(ajax)
    .then((response) => {
      GlobalAlerts.createAndShow({
        title: Lang.get('js/common/words.success'),
        message: response.message,
        type: 'success'
      });

      // Reatribuir o valor de required do campo de observação
      toggleRequiredObsAttribute(form, form.dataset.submitObsrequired);

      ga4.event(modalGA4[index]);

      if (refreshOnSuccess) {
        return reloadPage()
      }

      $(form).overlay('hide');

      if (closeModalOnSuccess) {
        $(modal).modal('hide');
      }
    })
    .catch((error) => {
      $(form).overlay('hide');

      error = error.responseJSON;

      // Erros genéricos
      if (error.data.failures === undefined) {
        showGenericErrorsCreateExpense(error, form);
      } else {
        // Erros de política tem o atributo pemiteUltrapassarLimite
        showLimitPolicyValidationErrors(error, form);
      }

      ga4.event(`${modalGA4[index]}Error`);
    })
    .then(() => {
      // Removendo a input de confirmação para exceder o limite da política
      removeInputConfirmationToExceedLimite(form);

      // Removendo a input de apagar recibo da despesa
      removeInputRemoverRecibo(form);

      // Restaurar o valor de disabled que as inputs tinham antes de
      // sere retirados para submiter os dados do form
      toggleDisabledInputs(inputsDisabled);

      // Habilitando o botão de submit novamente, para que outra
      // despesa possa ser submetida
      toggleDisabledInputs(buttonSubmit);
    });
}

/**
 * Habilitar/Desabilitar inputs
 *
 * @param {array} inputs
 */
function toggleDisabledInputs(inputs) {
  inputs.forEach((currentInput) => {
    currentInput.toggleAttribute('disabled');
  });
}

/**
 * Converter string com vírgula para float
 * @param {string} string
 */
function stringWithCommaAndDotsToFloat(string) {
  return parseFloat(string.replaceAll('.', '').replace(',', '.'));
}

/**
  * Soma de valores com 8 casas decimais
  *
  * @param {number} value1
  * @param {number} value2
  * @return {number}
  */
function sumValuesWithHeightDecimals(value1, value2) {
  return parseFloat((value1 + value2).toFixed(8));
}

/**
 * Adicionando os Rateios no FormData
 *
 * @param {Element} form
 * @param {FormData} formData
 * @param {string} formExpenseValue
 */
function setRateioInFormData(form, formData, formExpenseValue) {
  const containerRateios = form.querySelectorAll('.rateio');

  // Revovendo os valores antigos do FormData
  formData.delete('idEmpresaReembolsante[]');
  formData.delete('rateio[]');
  formData.delete('valorRateio[]');

  if (!containerRateios.length) {
    return formData;
  }

  let somaPercentualRateios = 0;
  containerRateios.forEach((currentContainer, n) => {
    // o percentual do input será desconsiderado para envio ao backend
    // const percentual = currentContainer.querySelector('[name="rateio[]"]').value;
    const valor = currentContainer.querySelector('[name="valorRateio[]"]').value;
    const idProjeto = currentContainer.querySelector('[name="idEmpresaReembolsante[]"]').value;

    const projectValueAsFloat = stringWithCommaAndDotsToFloat(valor);
    const expenseValueAsFloat = stringWithCommaAndDotsToFloat(formExpenseValue);

    // calcula o percentual do rateio com 8 casas decimais
    let percentualValue = (100 * projectValueAsFloat / expenseValueAsFloat).toFixed(8);

    // se for o último rateio, o percentual será o restante
    if (n + 1 === containerRateios.length) {
      percentualValue = sumValuesWithHeightDecimals(100, -somaPercentualRateios);
    } else {
      somaPercentualRateios = sumValuesWithHeightDecimals(somaPercentualRateios, parseFloat(percentualValue));
    }

    formData.set(`rateio[${idProjeto}]`, percentualValue);
    formData.set(`valorRateio[${idProjeto}]`, valor);
  });

  return formData;
}

/**
 * Adicinoando o recibo no FormData
 *
 * @param {Element} form
 * @param {FormData} data
 */
function setReceiptInFormData(form, formData) {
  const inputsFile = form.querySelectorAll('[type="file"]:not([id="anexosObs"])');

  if (!inputsFile.length) {
    return formData;
  }

  inputsFile.forEach((currentInput) => {
    if (currentInput.files.length) {
      // removendo o attributo antigo do recibo do formData
      formData.delete(currentInput.id);
      // Adicionando o novo atributo de recibo com o arquivo que foi carregado
      if (currentInput.files[0]) {
        formData.set('recibo', currentInput.files[0]);
      }
    }
  });

  return formData;
}

/**
 * Remove a kilometragem do FormData quando um percurso
 * é definido pelo usuário
 *
 * @param {Element} form
 * @param {FormData} formData
 */
function setMileageInFormData(form, formData) {
  const inputIdPercurso = form.querySelector('[name="idPercurso"]');

  if (document.body.contains(inputIdPercurso)) {
    if (inputIdPercurso.value) {
      formData.delete('kilometragem');
    }
  }

  return formData;
}

exports.init = GeneralFormsExpense;
